module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0743c_banner_800x600.6946d562.png";